import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
export function Layout() {
  const {
    pathname
  } = useLocation();
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="min-h-screen flex flex-col bg-engage-black text-engage-white font-sans selection:bg-engage-yellow selection:text-engage-black" data-id="element-131" data-mp="305bsb0t3kmg5">
      <Navbar data-id="element-132" data-mp="355r9y4kewg3x" />
      <main className="flex-grow" data-id="element-133" data-mp="3a27w4t81wked">
        <Outlet data-id="element-134" data-mp="3a16hkerttfrw" />
      </main>
      <Footer data-id="element-135" data-mp="3a4km9tnyq12i" />
    </div>;
}